
import React, { useEffect, useMemo, useState } from "react";
import AnatomicalTooth from "./components/dental/AnatomicalTooth";

const PERMANENTES = {
  superiorDerecho: [18, 17, 16, 15, 14, 13, 12, 11],
  superiorIzquierdo: [21, 22, 23, 24, 25, 26, 27, 28],
  inferiorDerecho: [48, 47, 46, 45, 44, 43, 42, 41],
  inferiorIzquierdo: [31, 32, 33, 34, 35, 36, 37, 38],
};

const PRIMARIOS = {
  superiorDerecho: [55, 54, 53, 52, 51],
  superiorIzquierdo: [61, 62, 63, 64, 65],
  inferiorDerecho: [85, 84, 83, 82, 81],
  inferiorIzquierdo: [71, 72, 73, 74, 75],
};

const CARAS = [
  { value: "vestibular", label: "Vestibular", short: "V" },
  { value: "mesial", label: "Mesial", short: "M" },
  { value: "distal", label: "Distal", short: "D" },
  { value: "lingual", label: "Lingual / palatina", short: "L" },
  { value: "oclusal", label: "Oclusal / incisal", short: "O" },
];

const CONDICIONES_CARA = [
  { value: "caries", label: "Caries cavitada", group: "Caries y lesiones", color: "#dc2626" },
  { value: "lesion_no_cavitada", label: "Lesión inicial no cavitada", group: "Caries y lesiones", color: "#ef4444" },
  { value: "caries_recurrente", label: "Caries recurrente", group: "Caries y lesiones", color: "#b91c1c" },
  { value: "restauracion", label: "Restauración existente", group: "Restauraciones", color: "#2563eb" },
  { value: "restauracion_defectuosa", label: "Restauración defectuosa", group: "Restauraciones", color: "#4f46e5" },
  { value: "restauracion_temporal", label: "Restauración temporal", group: "Restauraciones", color: "#0891b2" },
  { value: "sellador", label: "Sellador", group: "Restauraciones", color: "#16a34a" },
  { value: "fractura", label: "Fractura de superficie", group: "Desgaste y trauma", color: "#ea580c" },
  { value: "desgaste", label: "Desgaste", group: "Desgaste y trauma", color: "#ca8a04" },
  { value: "atricion", label: "Atrición", group: "Desgaste y trauma", color: "#a16207" },
  { value: "erosion", label: "Erosión", group: "Desgaste y trauma", color: "#9333ea" },
  { value: "abrasion", label: "Abrasión", group: "Desgaste y trauma", color: "#854d0e" },
  { value: "mancha", label: "Mancha o pigmentación", group: "Otros hallazgos", color: "#92400e" },
  { value: "hipoplasia", label: "Hipoplasia del esmalte", group: "Otros hallazgos", color: "#64748b" },
  { value: "fluorosis", label: "Fluorosis", group: "Otros hallazgos", color: "#0f766e" },
];

const CONDICIONES_DIENTE = [
  { value: "ausente", label: "Diente ausente", group: "Estado del diente", color: "#9ca3af" },
  { value: "extraccion_indicada", label: "Extracción indicada", group: "Estado del diente", color: "#ea580c" },
  { value: "impactado", label: "Diente impactado", group: "Erupción y posición", color: "#db2777" },
  { value: "semi_erupcionado", label: "Semi-erupcionado", group: "Erupción y posición", color: "#ca8a04" },
  { value: "supernumerario", label: "Diente supernumerario", group: "Erupción y posición", color: "#be123c" },
  { value: "giroversion", label: "Giroversión", group: "Erupción y posición", color: "#c2410c" },
  { value: "extrusion", label: "Extrusión", group: "Erupción y posición", color: "#9a3412" },
  { value: "intrusion", label: "Intrusión", group: "Erupción y posición", color: "#7c2d12" },
  { value: "corona", label: "Corona", group: "Restauración y prótesis", color: "#7c3aed" },
  { value: "endodoncia", label: "Tratamiento endodóntico", group: "Restauración y prótesis", color: "#0d9488" },
  { value: "implante", label: "Implante", group: "Restauración y prótesis", color: "#64748b" },
  { value: "protesis", label: "Pilar de prótesis", group: "Restauración y prótesis", color: "#4f46e5" },
  { value: "remanente_radicular", label: "Remanente radicular", group: "Hallazgos clínicos", color: "#92400e" },
  { value: "reabsorcion_interna", label: "Reabsorción interna", group: "Hallazgos clínicos", color: "#b91c1c" },
  { value: "reabsorcion_externa", label: "Reabsorción externa", group: "Hallazgos clínicos", color: "#dc2626" },
  { value: "lesion_periapical", label: "Lesión periapical", group: "Hallazgos clínicos", color: "#be123c" },
  { value: "fistula", label: "Fístula", group: "Hallazgos clínicos", color: "#c2410c" },
  { value: "pulpa_normal", label: "Pulpa normal", group: "Diagnóstico pulpar", color: "#16a34a" },
  { value: "pulpitis_reversible", label: "Pulpitis reversible", group: "Diagnóstico pulpar", color: "#f59e0b" },
  { value: "pulpitis_irreversible_sintomatica", label: "Pulpitis irreversible sintomática", group: "Diagnóstico pulpar", color: "#dc2626" },
  { value: "pulpitis_irreversible_asintomatica", label: "Pulpitis irreversible asintomática", group: "Diagnóstico pulpar", color: "#b91c1c" },
  { value: "pulpitis_hiperplasica", label: "Pulpitis hiperplásica", group: "Diagnóstico pulpar", color: "#be123c" },
  { value: "necrosis_pulpar", label: "Necrosis pulpar", group: "Diagnóstico pulpar", color: "#475569" },
  { value: "tratamiento_previamente_iniciado", label: "Tratamiento previamente iniciado", group: "Diagnóstico pulpar", color: "#7c3aed" },
  { value: "tratamiento_previamente_realizado", label: "Tratamiento previamente realizado", group: "Diagnóstico pulpar", color: "#4f46e5" },
  { value: "tejidos_apicales_normales", label: "Tejidos apicales normales", group: "Diagnóstico periapical", color: "#16a34a" },
  { value: "periodontitis_apical_sintomatica", label: "Periodontitis apical sintomática", group: "Diagnóstico periapical", color: "#ea580c" },
  { value: "periodontitis_apical_asintomatica", label: "Periodontitis apical asintomática", group: "Diagnóstico periapical", color: "#c2410c" },
  { value: "absceso_apical_agudo", label: "Absceso apical agudo", group: "Diagnóstico periapical", color: "#dc2626" },
  { value: "absceso_apical_cronico", label: "Absceso apical crónico", group: "Diagnóstico periapical", color: "#b91c1c" },
  { value: "osteitis_condensante", label: "Osteítis condensante", group: "Diagnóstico periapical", color: "#9333ea" },
  { value: "gingivitis", label: "Gingivitis", group: "Diagnóstico periodontal", color: "#ec4899" },
  { value: "periodontitis_localizada", label: "Periodontitis localizada", group: "Diagnóstico periodontal", color: "#db2777" },
  { value: "periodontitis_generalizada", label: "Periodontitis generalizada", group: "Diagnóstico periodontal", color: "#be185d" },
  { value: "recesion_gingival", label: "Recesión gingival", group: "Diagnóstico periodontal", color: "#f97316" },
  { value: "involucramiento_de_furca", label: "Involucramiento de furca", group: "Diagnóstico periodontal", color: "#9a3412" },
  { value: "movilidad_grado_1", label: "Movilidad grado I", group: "Periodontal", color: "#b91c1c" },
  { value: "movilidad_grado_2", label: "Movilidad grado II", group: "Periodontal", color: "#dc2626" },
  { value: "movilidad_grado_3", label: "Movilidad grado III", group: "Periodontal", color: "#991b1b" },
];

const COLORES = Object.fromEntries(
  [...CONDICIONES_CARA, ...CONDICIONES_DIENTE].map((c) => [
    c.value,
    c.color,
  ])
);

const OPCIONES_DENTICION = [
  { value: "permanente", label: "Permanente" },
  { value: "primaria", label: "Primaria" },
  { value: "mixta", label: "Mixta" },
];

const obtenerDientes = (tipo) => {
  if (tipo === "permanente") return PERMANENTES;
  if (tipo === "primaria") return PRIMARIOS;
  return { ...PERMANENTES, ...PRIMARIOS };
};

function normalizarRegistros(registros) {
  if (Array.isArray(registros)) {
    return registros
      .filter((r) => r && typeof r === "object")
      .map((r) => {
        const face =
          r.face || r.cara || r.superficie || r.surface || "";

        return {
          ...r,
          scope:
            r.scope === "diente" ||
            r.tipo === "diente" ||
            r.alcance === "diente"
              ? "diente"
              : r.scope === "cara" ||
                  r.tipo === "cara" ||
                  r.alcance === "cara" ||
                  face
                ? "cara"
                : "diente",
          condition:
            r.condition ||
            r.condicion ||
            r.estado ||
            r.tipoCondicion ||
            r.tipoCondicionDental ||
            "",
          face,
        };
      })
      .filter((r) => r.condition);
  }

  if (registros == null || registros === false || registros === "") {
    return [];
  }

  if (
    typeof registros === "string" ||
    typeof registros === "number"
  ) {
    return [{ scope: "diente", condition: String(registros) }];
  }

  if (typeof registros !== "object") return [];

  for (const clave of [
    "registros",
    "condiciones",
    "hallazgos",
    "items",
  ]) {
    if (registros[clave] != null) {
      return normalizarRegistros(registros[clave]);
    }
  }

  const condicionDirecta =
    registros.condition ||
    registros.condicion ||
    registros.estado ||
    registros.tipoCondicion ||
    registros.tipoCondicionDental;

  if (condicionDirecta) {
    const face =
      registros.face ||
      registros.cara ||
      registros.superficie ||
      registros.surface ||
      "";

    return [
      {
        ...registros,
        scope:
          registros.scope ||
          registros.alcance ||
          (face ? "cara" : "diente"),
        condition: condicionDirecta,
        face,
      },
    ];
  }

  const resultado = [];

  for (const [clave, valor] of Object.entries(registros)) {
    if (valor == null || valor === false || valor === "") {
      continue;
    }

    const claveEsCara = CARAS.some((c) => c.value === clave);

    if (Array.isArray(valor)) {
      resultado.push(
        ...normalizarRegistros(valor).map((r) => ({
          ...r,
          ...(claveEsCara && !r.face
            ? { face: clave, scope: "cara" }
            : {}),
        }))
      );
      continue;
    }

    if (
      typeof valor === "string" ||
      typeof valor === "number"
    ) {
      resultado.push({
        scope: claveEsCara ? "cara" : "diente",
        condition: String(valor),
        ...(claveEsCara ? { face: clave } : {}),
      });
      continue;
    }

    if (typeof valor === "object") {
      resultado.push(
        ...normalizarRegistros(valor).map((r) => ({
          ...r,
          ...(claveEsCara && !r.face
            ? { face: clave, scope: "cara" }
            : {}),
        }))
      );
    }
  }

  return resultado.filter((r) => r.condition);
}

const nombreCondicion = (registro) => {
  const lista =
    registro.scope === "cara"
      ? CONDICIONES_CARA
      : CONDICIONES_DIENTE;

  return (
    lista.find((c) => c.value === registro.condition)?.label ||
    registro.condition ||
    "Condición clínica"
  );
};

const nombreCara = (cara) =>
  CARAS.find((c) => c.value === cara)?.label || cara;

const esAusente = (registros) =>
  normalizarRegistros(registros).some(
    (r) =>
      r.scope === "diente" &&
      r.condition === "ausente"
  );

function PiezaDental({
  numero,
  registros = [],
  seleccionada,
  onClick,
}) {
  const registrosNormalizados = normalizarRegistros(registros);
  const ausente = esAusente(registrosNormalizados);

  const condicionGeneral = [...registrosNormalizados]
    .reverse()
    .find(
      (r) =>
        r.scope === "diente" &&
        r.condition !== "ausente"
    );

  const colorGeneral = condicionGeneral
    ? COLORES[condicionGeneral.condition]
    : null;

  const colorCara = (cara) => {
    if (ausente) return "#e5e7eb";
    if (colorGeneral) return colorGeneral;

    const registro = [...registrosNormalizados]
      .reverse()
      .find(
        (r) =>
          r.scope === "cara" &&
          r.face === cara
      );

    return registro
      ? COLORES[registro.condition] || "#dc2626"
      : "#ffffff";
  };

  return (
    <button
      type="button"
      className={`odx-tooth ${
        seleccionada ? "is-selected" : ""
      } ${ausente ? "is-absent" : ""}`}
      onClick={() => onClick(numero)}
      aria-label={`Diente ${numero}${ausente ? ", ausente" : ""}`}
      aria-pressed={seleccionada}
      title={`Diente ${numero}`}
    >
      <AnatomicalTooth
        numero={numero}
        colors={{
          vestibular: colorCara("vestibular"),
          mesial: colorCara("mesial"),
          distal: colorCara("distal"),
          lingual: colorCara("lingual"),
          oclusal: colorCara("oclusal"),
        }}
        selected={seleccionada}
        absent={ausente}
      />

      {registrosNormalizados.length > 0 && !ausente && (
        <span className="odx-tooth-indicator" />
      )}
    </button>
  );
}

function Arcada({
  titulo,
  derecha,
  izquierda,
  condiciones,
  seleccionado,
  onSelect,
}) {
  return (
    <section className="odx-arch">
      <div className="odx-arch-title">{titulo}</div>

      <div className="odx-arch-row">
        <div className="odx-quadrant">
          {derecha.map((numero) => (
            <PiezaDental
              key={numero}
              numero={numero}
              registros={condiciones[numero] || []}
              seleccionada={seleccionado === numero}
              onClick={onSelect}
            />
          ))}
        </div>

        <div className="odx-midline" />

        <div className="odx-quadrant">
          {izquierda.map((numero) => (
            <PiezaDental
              key={numero}
              numero={numero}
              registros={condiciones[numero] || []}
              seleccionada={seleccionado === numero}
              onClick={onSelect}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Odontograma({
  value,
  onChange,
  readOnly = false,
}) {
  const [denticion, setDenticion] = useState("permanente");

  const [condiciones, setCondiciones] = useState(() => {
    if (
      !value ||
      typeof value !== "object" ||
      Array.isArray(value)
    ) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(value).map(([numero, registros]) => [
        numero,
        normalizarRegistros(registros),
      ])
    );
  });

  const [seleccionado, setSeleccionado] = useState(null);
  const [alcance, setAlcance] = useState("cara");
  const [carasSeleccionadas, setCarasSeleccionadas] = useState([
    "vestibular",
  ]);
  const [condicion, setCondicion] = useState("");
  const [busquedaCondicion, setBusquedaCondicion] = useState("");
  const [pasoPopup, setPasoPopup] = useState("ambito");

  useEffect(() => {
    if (
      !value ||
      typeof value !== "object" ||
      Array.isArray(value)
    ) {
      setCondiciones({});
      return;
    }

    setCondiciones(
      Object.fromEntries(
        Object.entries(value).map(([numero, registros]) => [
          numero,
          normalizarRegistros(registros),
        ])
      )
    );
  }, [value]);

  const dientes = useMemo(
    () => obtenerDientes(denticion),
    [denticion]
  );

  const resumen = useMemo(() => {
    const entradas = Object.entries(condiciones).map(
      ([numero, registros]) => [
        numero,
        normalizarRegistros(registros),
      ]
    );

    return {
      piezasRegistradas: entradas.filter(
        ([, registros]) => registros.length > 0
      ).length,

      carasConHallazgos: entradas.reduce(
        (total, [, registros]) =>
          total +
          registros.filter((r) => r.scope === "cara").length,
        0
      ),

      ausentes: entradas.filter(([, registros]) =>
        esAusente(registros)
      ).length,
    };
  }, [condiciones]);

  const registrosSeleccionados =
    seleccionado !== null
      ? normalizarRegistros(condiciones[seleccionado])
      : [];

  const opcionesCondicion =
    alcance === "cara" ? CONDICIONES_CARA : CONDICIONES_DIENTE;

  const opcionesCondicionFiltradas = useMemo(() => {
    const query = busquedaCondicion.trim().toLocaleLowerCase();

    if (!query) return opcionesCondicion;

    return opcionesCondicion.filter((item) =>
      `${item.label} ${item.group || ""}`
        .toLocaleLowerCase()
        .includes(query)
    );
  }, [busquedaCondicion, opcionesCondicion]);

  function actualizar(nuevas) {
    setCondiciones(nuevas);
    onChange?.(nuevas);
  }

  function seleccionarDiente(numero) {
    setSeleccionado(numero);
    setAlcance("cara");
    setCarasSeleccionadas(["vestibular"]);
    setCondicion("");
    setBusquedaCondicion("");
    setPasoPopup(readOnly ? "consulta" : "ambito");
  }

  function guardarCondicionDirecto(valor) {
    if (seleccionado === null || !valor) return;

    const actuales = normalizarRegistros(
      condiciones[seleccionado]
    );

    let siguientes;

    if (valor === "ausente") {
      siguientes = [
        { scope: "diente", condition: "ausente" },
      ];
    } else {
      siguientes = [
        ...actuales.filter(
          (r) =>
            !(
              r.scope === "diente" &&
              r.condition === "ausente"
            )
        ),
        { scope: "diente", condition: valor },
      ];
    }

    actualizar({
      ...condiciones,
      [seleccionado]: siguientes,
    });

    setCondicion("");
    setBusquedaCondicion("");
    setPasoPopup("ambito");
  }

  function guardarCondicion() {
    if (seleccionado === null || !condicion || !alcance) {
      return;
    }

    const actuales = normalizarRegistros(
      condiciones[seleccionado]
    );

    let siguientes;

    if (alcance === "diente") {
      const nuevo = {
        scope: "diente",
        condition: condicion,
      };

      if (condicion === "ausente") {
        siguientes = [nuevo];
      } else {
        siguientes = [
          ...actuales.filter(
            (registro) =>
              !(
                registro.scope === "diente" &&
                registro.condition === "ausente"
              )
          ),
          nuevo,
        ];
      }
    } else {
      if (carasSeleccionadas.length === 0) return;

      const carasNuevas = new Set(carasSeleccionadas);

      siguientes = actuales.filter(
        (registro) =>
          registro.scope !== "cara" ||
          !carasNuevas.has(registro.face)
      );

      carasSeleccionadas.forEach((caraSeleccionada) => {
        siguientes.push({
          scope: "cara",
          condition: condicion,
          face: caraSeleccionada,
        });
      });
    }

    actualizar({
      ...condiciones,
      [seleccionado]: siguientes,
    });

    setCondicion("");
    setBusquedaCondicion("");
    setCarasSeleccionadas(["vestibular"]);
    setPasoPopup("ambito");
  }

  function quitarRegistro(indice) {
    const actuales = normalizarRegistros(
      condiciones[seleccionado]
    );

    const siguientes = actuales.filter(
      (_, i) => i !== indice
    );

    const nuevas = { ...condiciones };

    if (siguientes.length) {
      nuevas[seleccionado] = siguientes;
    } else {
      delete nuevas[seleccionado];
    }

    actualizar(nuevas);
  }

  function eliminarRegistroLista(numero, indice) {
    if (readOnly) return;

    const actuales = normalizarRegistros(condiciones[numero]);
    const siguientes = actuales.filter((_, i) => i !== indice);
    const nuevas = { ...condiciones };

    if (siguientes.length > 0) {
      nuevas[numero] = siguientes;
    } else {
      delete nuevas[numero];
    }

    actualizar(nuevas);
  }

  function cerrarPanel() {
    setSeleccionado(null);
    setCondicion("");
    setBusquedaCondicion("");
    setCarasSeleccionadas(["vestibular"]);
    setPasoPopup("ambito");
  }

  return (
    <div className="odx-workspace">
      <style>{`
        .odx-workspace {
          color: #172b4d;
          font-family: inherit;
          min-width: 0;
        }

        .odx-workspace * { box-sizing: border-box; }

        .odx-workspace button,
        .odx-workspace input,
        .odx-workspace select {
          font: inherit;
        }

        .odx-workspace button { cursor: pointer; }

        .odx-workspace button:disabled {
          cursor: not-allowed;
          opacity: .55;
        }

        .odx-topbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 14px;
          margin-bottom: 20px;
        }

        .odx-segment {
          display: inline-flex;
          flex-wrap: wrap;
          gap: 4px;
          background: #edf2f8;
          padding: 4px;
          border-radius: 12px;
        }

        .odx-segment button {
          border: 0;
          border-radius: 9px;
          background: transparent;
          color: #52627a;
          font-size: 13px;
          padding: 10px 15px;
          transition: background .16s ease, color .16s ease;
        }

        .odx-segment button.active {
          background: #2563eb;
          color: #fff;
          box-shadow: 0 2px 5px #1d4ed825;
        }

        .odx-summary {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 10px;
          margin-bottom: 18px;
        }

        .odx-stat {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 13px;
          border: 1px solid #e4ebf5;
          background: rgba(255,255,255,.8);
          border-radius: 13px;
          min-width: 0;
        }

        .odx-stat-icon {
          display: grid;
          place-items: center;
          flex-shrink: 0;
          width: 36px;
          height: 36px;
          border-radius: 11px;
          background: #eaf2ff;
          color: #2563eb;
          font-size: 17px;
          font-weight: 700;
        }

        .odx-stat strong {
          display: block;
          font-size: 20px;
          line-height: 1.2;
          color: #1e293b;
        }

        .odx-stat span {
          display: block;
          margin-top: 3px;
          font-size: 11px;
          color: #718198;
        }

        .odx-main-grid {
          display: grid;
          grid-template-columns: minmax(0, 1fr);
          gap: 16px;
          align-items: start;
        }

        .odx-chart {
          min-width: 0;
          border: 1px solid #e2eaf4;
          border-radius: 15px;
          padding: 18px 12px;
          background: rgba(255,255,255,.56);
        }

        .odx-chart-heading {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          margin: 0 4px 20px;
        }

        .odx-chart-heading strong {
          font-size: 14px;
          color: #263b58;
        }

        .odx-chart-heading span {
          color: #8190a5;
          font-size: 11px;
        }

        .odx-arch { margin: 0 0 26px; }
        .odx-arch:last-child { margin-bottom: 0; }

        .odx-arch-title {
          text-align: center;
          color: #738198;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: .09em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }

        .odx-arch-row {
          display: flex;
          justify-content: center;
          align-items: stretch;
          gap: 5px;
        }

        .odx-quadrant {
          display: flex;
          flex: 1 1 0;
          justify-content: center;
          align-items: flex-start;
          gap: 1px;
          min-width: 0;
        }

        .odx-midline {
          width: 1px;
          flex-shrink: 0;
          background: #dbe4ef;
          margin: 0 3px;
          min-height: 66px;
        }

        .odx-tooth {
          position: relative;
          display: flex;
          flex: 1 1 0;
          flex-direction: column;
          align-items: center;
          gap: 3px;
          min-width: 0;
          max-width: 60px;
          padding: 4px 0 5px;
          border: 1px solid transparent;
          border-radius: 10px;
          background: transparent;
          transition: background .15s, border-color .15s, transform .15s;
        }

        .odx-tooth:hover {
          background: #eff6ff;
          border-color: #bfdbfe;
          transform: translateY(-2px);
        }

        .odx-tooth.is-selected {
          background: #eaf2ff;
          border-color: #3b82f6;
          box-shadow: 0 0 0 2px #bfdbfe55;
        }

        .odx-tooth.is-absent { background: #f3f4f6; }

        .odx-tooth-svg {
          display: block;
          width: 100%;
          max-width: 53px;
          height: auto;
          overflow: visible;
        }

        .odx-tooth .vd-anatomical-tooth {
          display: block;
          max-width: 100%;
          overflow: visible;
          transition: filter .16s ease;
        }

        .odx-tooth:hover .vd-anatomical-tooth {
          filter: drop-shadow(0 5px 5px rgba(37, 99, 235, .16));
        }

        .odx-tooth-number {
          color: #475569;
          font-size: 11px;
          font-weight: 750;
        }

        .odx-tooth-indicator {
          position: absolute;
          top: 1px;
          right: 4px;
          width: 7px;
          height: 7px;
          background: #2563eb;
          border: 1px solid white;
          border-radius: 50%;
        }

        .odx-modal-backdrop {
          position: fixed;
          inset: 0;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px;
          background: rgba(15, 23, 42, .52);
          backdrop-filter: blur(5px);
          overflow-y: auto;
        }

        .odx-modal {
          width: min(100%, 620px);
          max-height: min(88dvh, 760px);
          overflow-y: auto;
          background: #fff;
          border: 1px solid #dce6f2;
          border-radius: 20px;
          box-shadow: 0 24px 80px #0f172a45;
          animation: odx-modal-in .16s ease-out;
        }

        @keyframes odx-modal-in {
          from { opacity: 0; transform: translateY(8px) scale(.985); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        .odx-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
          padding: 20px 22px 16px;
          background: linear-gradient(135deg, #eff6ff, #fff);
          border-bottom: 1px solid #e5edf7;
        }

        .odx-modal-header small {
          color: #647da0;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: .1em;
        }

        .odx-modal-header h3 {
          margin: 5px 0 2px;
          font-size: 25px;
          color: #1e293b;
        }

        .odx-modal-header p {
          margin: 0;
          font-size: 12px;
          color: #7b8ba1;
        }

        .odx-modal-body { padding: 20px 22px 22px; }

        .odx-modal-body h4 {
          margin: 0 0 8px;
          font-size: 17px;
          color: #263b58;
        }

        .odx-step-description {
          margin: 0 0 15px;
          font-size: 12px;
          color: #718198;
          line-height: 1.55;
        }

        .odx-choice-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          margin-top: 16px;
        }

        .odx-choice {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 7px;
          padding: 17px 14px;
          border: 1px solid #dce6f2;
          border-radius: 13px;
          background: #fff;
          text-align: left;
          color: #334155;
        }

        .odx-choice:hover {
          border-color: #60a5fa;
          background: #f5f9ff;
        }

        .odx-choice-icon {
          display: grid;
          place-items: center;
          width: 34px;
          height: 34px;
          border-radius: 10px;
          background: #eaf2ff;
          color: #2563eb;
          font-size: 21px;
        }

        .odx-choice strong { font-size: 13px; }

        .odx-choice small {
          color: #8291a5;
          font-size: 11px;
          line-height: 1.4;
        }

        .odx-back {
          border: 0;
          background: transparent;
          color: #2563eb;
          font-size: 12px;
          font-weight: 700;
          padding: 0;
          margin: 0 0 16px;
        }

        .odx-condition-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-top: 12px;
          max-height: 365px;
          overflow-y: auto;
          padding-right: 3px;
        }

        .odx-modal-context {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
          padding: 10px 12px;
          border: 1px solid #e1eaf5;
          border-radius: 12px;
          background: #f8fbff;
          color: #56708f;
          font-size: 12px;
        }

        .odx-modal-context strong { color: #1e3a5f; }

        .odx-search-wrap {
          position: relative;
          display: flex;
          align-items: center;
          gap: 8px;
          margin: 0 0 10px;
          padding: 0 12px;
          border: 1px solid #cbd9ea;
          border-radius: 12px;
          background: #fff;
          transition: border-color .15s, box-shadow .15s;
        }

        .odx-search-wrap:focus-within {
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px #dbeafe;
        }

        .odx-search-icon {
          color: #6b86a4;
          font-size: 17px;
          line-height: 1;
        }

        .odx-search-input {
          width: 100%;
          min-width: 0;
          padding: 12px 0;
          border: 0;
          outline: 0;
          background: transparent;
          color: #1e293b;
          font-size: 13px;
        }

        .odx-search-clear {
          border: 0;
          background: transparent;
          color: #64748b;
          font-size: 17px;
          line-height: 1;
          padding: 3px;
        }

        .odx-condition-meta {
          display: flex;
          justify-content: space-between;
          gap: 10px;
          margin: 0 0 9px;
          color: #7b8da4;
          font-size: 11px;
        }

        .odx-condition-option {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          width: 100%;
          padding: 12px 13px;
          border: 1px solid #e1e8f1;
          border-radius: 12px;
          background: #fff;
          color: #334155;
          text-align: left;
          font-size: 13px;
          transition: border-color .15s, background .15s, transform .15s;
        }

        .odx-condition-option:hover {
          border-color: #93c5fd;
          background: #f8fbff;
          transform: translateY(-1px);
        }

        .odx-condition-color {
          width: 12px;
          height: 12px;
          margin-top: 3px;
          border-radius: 4px;
          flex-shrink: 0;
        }

        .odx-condition-label {
          display: flex;
          flex: 1;
          flex-direction: column;
          gap: 3px;
          min-width: 0;
        }

        .odx-condition-label small {
          color: #8a9bb0;
          font-size: 10px;
          font-weight: 600;
        }

        .odx-option-arrow {
          margin-left: auto;
          color: #94a3b8;
          font-size: 20px;
        }

        .odx-face-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 9px;
          margin: 14px 0 10px;
        }

        .odx-face-option {
          display: flex;
          align-items: center;
          gap: 9px;
          min-height: 64px;
          padding: 10px 11px;
          border: 1px solid #e1e8f1;
          border-radius: 10px;
          background: #fff;
          color: #334155;
          font-size: 12px;
          text-align: left;
          transition: border-color .15s, background .15s, transform .15s;
        }

        .odx-face-option.selected {
          border-color: #3b82f6;
          background: #eff6ff;
          color: #1d4ed8;
          box-shadow: 0 5px 14px #2563eb18;
          transform: translateY(-1px);
        }

        .odx-face-symbol {
          display: grid;
          place-items: center;
          width: 28px;
          height: 28px;
          flex-shrink: 0;
          border-radius: 8px;
          background: #edf2f8;
          font-weight: 800;
        }

        .odx-face-copy {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }

        .odx-face-copy small {
          color: #8291a5;
          font-size: 10px;
          line-height: 1.25;
        }

        .odx-face-option.selected .odx-face-symbol {
          background: #dbeafe;
        }

        .odx-face-summary {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          padding: 10px 12px;
          border-radius: 11px;
          background: #f8fafc;
          color: #64748b;
          font-size: 11px;
        }

        .odx-face-summary strong { color: #1e3a5f; }

        .odx-face-select-all {
          border: 0;
          background: transparent;
          color: #2563eb;
          font-size: 11px;
          font-weight: 800;
          padding: 2px;
        }

        .odx-primary {
          width: 100%;
          padding: 11px 13px;
          border: 0;
          border-radius: 9px;
          background: #2563eb;
          color: white;
          font-size: 13px;
          font-weight: 750;
        }

        .odx-primary:disabled {
          opacity: .45;
          cursor: not-allowed;
        }

        .odx-close {
          width: 34px;
          height: 34px;
          flex-shrink: 0;
          border: 1px solid #e1e8f2;
          background: white;
          color: #52627a;
          border-radius: 9px;
          cursor: pointer;
          font-size: 21px;
        }

        .odx-subtitle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          margin: 20px 0 9px;
          font-size: 12px;
          font-weight: 800;
          color: #344863;
        }

        .odx-count {
          padding: 3px 7px;
          border-radius: 20px;
          background: #edf2f8;
          color: #64748b;
          font-size: 10px;
        }

        .odx-empty {
          padding: 14px 10px;
          text-align: center;
          color: #8a98ab;
          background: #f8fafc;
          border: 1px dashed #dce5ef;
          border-radius: 10px;
          font-size: 12px;
          line-height: 1.5;
        }

        .odx-record {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 8px;
          padding: 10px 0;
          border-bottom: 1px solid #edf1f6;
        }

        .odx-record:last-child { border-bottom: 0; }

        .odx-record-name {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          min-width: 0;
          font-size: 12px;
          line-height: 1.45;
          color: #334155;
        }

        .odx-record-dot {
          width: 9px;
          height: 9px;
          margin-top: 4px;
          flex-shrink: 0;
          border-radius: 3px;
        }

        .odx-record-name small {
          display: block;
          margin-top: 3px;
          color: #8291a5;
          font-size: 10px;
        }

        .odx-remove {
          flex-shrink: 0;
          border: 0;
          border-radius: 6px;
          padding: 5px 7px;
          background: #fff1f2;
          color: #be123c;
          font-size: 11px;
        }

        @media (max-width: 950px) {
          .odx-main-grid { grid-template-columns: minmax(0, 1fr); }
        }

        @media (max-width: 560px) {
          .odx-summary { gap: 6px; }

          .odx-stat {
            flex-direction: column;
            align-items: flex-start;
            padding: 9px;
            gap: 7px;
          }

          .odx-stat-icon {
            width: 30px;
            height: 30px;
          }

          .odx-stat strong { font-size: 18px; }
          .odx-stat span { font-size: 10px; }
          .odx-chart { padding: 12px 4px; }
          .odx-arch-row { gap: 1px; }
          .odx-midline { margin: 0 1px; }

          .odx-tooth {
            padding: 3px 0;
            border-radius: 6px;
          }

          .odx-tooth .vd-anatomical-tooth { width: 48px !important; height: 62px !important; }
          .odx-tooth-number { font-size: 11px; }
          .odx-tooth-indicator { right: 1px; }

          .odx-segment button {
            padding: 9px 10px;
            font-size: 12px;
          }

          .odx-modal-backdrop {
            align-items: flex-end;
            padding: 0;
          }

          .odx-modal {
            width: 100%;
            max-height: 88dvh;
            border-radius: 20px 20px 0 0;
          }

          .odx-modal-header { padding: 17px 18px 14px; }

          .odx-modal-body {
            padding: 17px 18px calc(20px + env(safe-area-inset-bottom));
          }

          .odx-choice { padding: 13px 10px; }
          .odx-face-grid { grid-template-columns: 1fr 1fr; }
          .odx-condition-list { max-height: 330px; }
        }
      `}</style>

      <div className="odx-topbar">
        <div
          className="odx-segment"
          role="group"
          aria-label="Tipo de dentición"
        >
          {OPCIONES_DENTICION.map((opcion) => (
            <button
              type="button"
              key={opcion.value}
              className={
                denticion === opcion.value ? "active" : ""
              }
              aria-pressed={denticion === opcion.value}
              onClick={() => {
                setDenticion(opcion.value);
                setSeleccionado(null);
              }}
            >
              {opcion.label}
            </button>
          ))}
        </div>

        <span style={{ color: "#7c8ba0", fontSize: 12 }}>
          {readOnly
            ? "Modo de solo lectura"
            : "Selecciona una pieza para registrar hallazgos"}
        </span>
      </div>

      <div className="odx-summary">
        <div className="odx-stat">
          <div className="odx-stat-icon">◉</div>
          <div>
            <strong>{resumen.piezasRegistradas}</strong>
            <span>Piezas registradas</span>
          </div>
        </div>

        <div className="odx-stat">
          <div
            className="odx-stat-icon"
            style={{ background: "#fff1f2", color: "#e11d48" }}
          >
            ⌁
          </div>
          <div>
            <strong>{resumen.carasConHallazgos}</strong>
            <span>Condiciones por cara</span>
          </div>
        </div>

        <div className="odx-stat">
          <div
            className="odx-stat-icon"
            style={{ background: "#f1f5f9", color: "#64748b" }}
          >
            −
          </div>
          <div>
            <strong>{resumen.ausentes}</strong>
            <span>Piezas ausentes</span>
          </div>
        </div>
      </div>

      <div className="odx-main-grid">
        <div className="odx-chart">
          <div className="odx-chart-heading">
            <strong>Mapa dental</strong>
            <span>Numeración FDI · Vista clínica</span>
          </div>

          {denticion === "mixta" ? (
            <>
              <Arcada
                titulo="Arcada superior · permanente"
                derecha={PERMANENTES.superiorDerecho}
                izquierda={PERMANENTES.superiorIzquierdo}
                condiciones={condiciones}
                seleccionado={seleccionado}
                onSelect={seleccionarDiente}
              />

              <Arcada
                titulo="Arcada superior · primaria"
                derecha={PRIMARIOS.superiorDerecho}
                izquierda={PRIMARIOS.superiorIzquierdo}
                condiciones={condiciones}
                seleccionado={seleccionado}
                onSelect={seleccionarDiente}
              />

              <Arcada
                titulo="Arcada inferior · primaria"
                derecha={PRIMARIOS.inferiorDerecho}
                izquierda={PRIMARIOS.inferiorIzquierdo}
                condiciones={condiciones}
                seleccionado={seleccionado}
                onSelect={seleccionarDiente}
              />

              <Arcada
                titulo="Arcada inferior · permanente"
                derecha={PERMANENTES.inferiorDerecho}
                izquierda={PERMANENTES.inferiorIzquierdo}
                condiciones={condiciones}
                seleccionado={seleccionado}
                onSelect={seleccionarDiente}
              />
            </>
          ) : (
            <>
              <Arcada
                titulo="Arcada superior"
                derecha={dientes.superiorDerecho}
                izquierda={dientes.superiorIzquierdo}
                condiciones={condiciones}
                seleccionado={seleccionado}
                onSelect={seleccionarDiente}
              />

              <Arcada
                titulo="Arcada inferior"
                derecha={dientes.inferiorDerecho}
                izquierda={dientes.inferiorIzquierdo}
                condiciones={condiciones}
                seleccionado={seleccionado}
                onSelect={seleccionarDiente}
              />
            </>
          )}
        </div>
      </div>

      <section
        aria-label="Listado de condiciones dentales"
        style={{
          marginTop: 20,
          padding: 18,
          border: "1px solid #e2e8f0",
          borderRadius: 14,
          background: "#fff",
        }}
      >
        <h3 style={{ margin: "0 0 12px", fontSize: 16, color: "#172b4d" }}>
          Listado de condiciones dentales
        </h3>

        {Object.entries(condiciones)
          .map(([numero, registros]) => [
            numero,
            normalizarRegistros(registros),
          ])
          .filter(([, registros]) => registros.length > 0)
          .sort(([a], [b]) => Number(a) - Number(b))
          .length === 0 ? (
          <p style={{ margin: 0, color: "#7c8ba0", fontSize: 13 }}>
            No hay condiciones registradas.
          </p>
        ) : (
          <div style={{ display: "grid", gap: 12 }}>
            {Object.entries(condiciones)
              .map(([numero, registros]) => [
                numero,
                normalizarRegistros(registros),
              ])
              .filter(([, registros]) => registros.length > 0)
              .sort(([a], [b]) => Number(a) - Number(b))
              .map(([numero, registros]) => (
                <div
                  key={numero}
                  style={{
                    padding: 12,
                    border: "1px solid #e2e8f0",
                    borderRadius: 10,
                  }}
                >
                  <strong
                    style={{
                      display: "block",
                      marginBottom: 8,
                      color: "#172b4d",
                      fontSize: 14,
                    }}
                  >
                    Diente {numero}
                  </strong>

                  <div style={{ display: "grid", gap: 7 }}>
                    {registros.map((registro, indice) => (
                      <div
                        key={`${numero}-${indice}`}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 12,
                          padding: "8px 10px",
                          background: "#f8fafc",
                          borderRadius: 8,
                        }}
                      >
                        <span style={{ color: "#334155", fontSize: 13 }}>
                          {registro.scope === "cara"
                            ? `${nombreCondicion(registro)} (${nombreCara(registro.face)})`
                            : nombreCondicion(registro)}
                        </span>

                        {!readOnly && (
                          <button
                            type="button"
                            title="Eliminar condición"
                            aria-label={`Eliminar ${nombreCondicion(registro)} del diente ${numero}`}
                            onClick={() =>
                              eliminarRegistroLista(numero, indice)
                            }
                            style={{
                              flexShrink: 0,
                              border: "1px solid #fecaca",
                              borderRadius: 7,
                              background: "#fff1f2",
                              color: "#dc2626",
                              padding: "5px 9px",
                              cursor: "pointer",
                              fontSize: 12,
                              fontWeight: 600,
                            }}
                          >
                            Eliminar
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        )}
      </section>

      {seleccionado !== null && (
        <div
          className="odx-modal-backdrop"
          role="presentation"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) cerrarPanel();
          }}
        >
          <section
            className="odx-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="odx-modal-title"
          >
            <header className="odx-modal-header">
              <div>
                <small>ODONTOGRAMA CLÍNICO</small>
                <h3 id="odx-modal-title">Diente {seleccionado}</h3>
                <p>
                  {readOnly
                    ? "Consulta de condiciones"
                    : pasoPopup === "ambito"
                      ? "Paso 1 · Selecciona el área"
                      : pasoPopup === "condicion"
                        ? "Paso 2 · Selecciona la afectación"
                        : pasoPopup === "cara"
                          ? "Paso 3 · Selecciona las caras"
                          : ""}
                </p>
              </div>

              <button
                type="button"
                className="odx-close"
                onClick={cerrarPanel}
                aria-label="Cerrar ventana"
              >
                ×
              </button>
            </header>

            <div className="odx-modal-body">
              {readOnly || pasoPopup === "consulta" ? (
                <>
                  <h4>Condiciones registradas</h4>

                  {registrosSeleccionados.length === 0 ? (
                    <div className="odx-empty">
                      Esta pieza no tiene condiciones registradas.
                    </div>
                  ) : (
                    registrosSeleccionados.map((registro, indice) => (
                      <div
                        className="odx-record"
                        key={`${registro.condition}-${indice}`}
                      >
                        <div className="odx-record-name">
                          <span
                            className="odx-record-dot"
                            style={{
                              background:
                                COLORES[registro.condition] || "#64748b",
                            }}
                          />
                          <span>
                            {nombreCondicion(registro)}
                            <small>
                              {registro.scope === "cara"
                                ? nombreCara(registro.face)
                                : "Diente completo"}
                            </small>
                          </span>
                        </div>
                      </div>
                    ))
                  )}
                </>
              ) : (
                <>
                  {pasoPopup === "ambito" && (
                    <>
                      <h4>¿Qué deseas registrar?</h4>
                      <p className="odx-step-description">
                        Elige si la condición afecta toda la pieza o una o
                        varias superficies dentales.
                      </p>

                      <div className="odx-choice-grid">
                        <button
                          type="button"
                          className="odx-choice"
                          onClick={() => {
                            setAlcance("diente");
                            setCondicion("");
                            setPasoPopup("condicion");
                          }}
                        >
                          <span className="odx-choice-icon">◉</span>
                          <strong>Diente completo</strong>
                          <small>Condiciones de toda la pieza</small>
                        </button>

                        <button
                          type="button"
                          className="odx-choice"
                          onClick={() => {
                            setAlcance("cara");
                            setCondicion("");
                            setCarasSeleccionadas([]);
                            setPasoPopup("condicion");
                          }}
                        >
                          <span className="odx-choice-icon">◌</span>
                          <strong>Cara dental</strong>
                          <small>Una o varias superficies</small>
                        </button>
                      </div>
                    </>
                  )}

                  {pasoPopup === "condicion" && (
                    <>
                      <button
                        type="button"
                        className="odx-back"
                        onClick={() => setPasoPopup("ambito")}
                      >
                        ← Cambiar selección
                      </button>

                      <h4>
                        {alcance === "cara"
                          ? "¿Qué afectación presenta?"
                          : "¿Qué condición afecta al diente?"}
                      </h4>

                      <div className="odx-modal-context">
                        <span>
                          Registrando en: <strong>{alcance === "cara" ? "una superficie dental" : "el diente completo"}</strong>
                        </span>
                        <span>{opcionesCondicion.length} opciones clínicas</span>
                      </div>

                      <label className="odx-search-wrap" htmlFor="odx-condition-search">
                        <span className="odx-search-icon" aria-hidden="true">⌕</span>
                        <input
                          id="odx-condition-search"
                          className="odx-search-input"
                          type="search"
                          value={busquedaCondicion}
                          onChange={(event) => setBusquedaCondicion(event.target.value)}
                          placeholder={alcance === "cara" ? "Buscar caries, restauración, fractura..." : "Buscar corona, implante, movilidad..."}
                          autoComplete="off"
                        />
                        {busquedaCondicion && (
                          <button
                            type="button"
                            className="odx-search-clear"
                            aria-label="Limpiar búsqueda"
                            onClick={() => setBusquedaCondicion("")}
                          >
                            ×
                          </button>
                        )}
                      </label>

                      <div className="odx-condition-meta">
                        <span>{opcionesCondicionFiltradas.length} resultados</span>
                        <span>Selecciona una opción para continuar</span>
                      </div>

                      <div className="odx-condition-list">
                        {opcionesCondicionFiltradas.length === 0 ? (
                          <div className="odx-empty">
                            No encontramos una condición con ese término. Prueba con otra palabra.
                          </div>
                        ) : opcionesCondicionFiltradas.map((item) => (
                          <button
                            type="button"
                            key={item.value}
                            className="odx-condition-option"
                            onClick={() => {
                              if (alcance === "cara") {
                                setCondicion(item.value);
                                setCarasSeleccionadas([]);
                                setPasoPopup("cara");
                              } else {
                                guardarCondicionDirecto(item.value);
                              }
                            }}
                          >
                            <span
                              className="odx-condition-color"
                              style={{ background: item.color }}
                            />
                            <span className="odx-condition-label">
                              <span>{item.label}</span>
                              <small>{item.group}</small>
                            </span>
                            <span className="odx-option-arrow">›</span>
                          </button>
                        ))}
                      </div>
                    </>
                  )}

                  {pasoPopup === "cara" && (
                    <>
                      <button
                        type="button"
                        className="odx-back"
                        onClick={() => setPasoPopup("condicion")}
                      >
                        ← Cambiar afectación
                      </button>

                      <h4>Selecciona una o varias caras</h4>

                      <p className="odx-step-description">
                        Elige exactamente dónde se encuentra la afectación. Puedes seleccionar varias superficies antes de guardar.
                      </p>

                      <div className="odx-modal-context">
                        <span>
                          Condición: <strong>
                            {CONDICIONES_CARA.find(
                              (c) => c.value === condicion
                            )?.label || condicion}
                          </strong>
                        </span>
                        <button
                          type="button"
                          className="odx-search-clear"
                          onClick={() => setCarasSeleccionadas(CARAS.map((cara) => cara.value))}
                        >
                          Seleccionar todas
                        </button>
                      </div>

                      <div className="odx-face-grid">
                        {CARAS.map((item) => {
                          const seleccionada = carasSeleccionadas.includes(
                            item.value
                          );

                          return (
                            <button
                              type="button"
                              key={item.value}
                              className={`odx-face-option ${
                                seleccionada ? "selected" : ""
                              }`}
                              aria-pressed={seleccionada}
                              onClick={() => {
                                setCarasSeleccionadas((actuales) =>
                                  actuales.includes(item.value)
                                    ? actuales.filter(
                                        (cara) => cara !== item.value
                                      )
                                    : [...actuales, item.value]
                                );
                              }}
                            >
                              <span className="odx-face-symbol">
                                {item.short}
                              </span>
                              <span className="odx-face-copy">
                                <span>{item.label}</span>
                                <small>
                                  {item.value === "vestibular"
                                    ? "Frontal / labial"
                                    : item.value === "lingual"
                                      ? "Interna / palatina"
                                      : item.value === "oclusal"
                                        ? "Masticatoria / borde"
                                        : "Lateral de contacto"}
                                </small>
                              </span>
                              {seleccionada && (
                                <span aria-hidden="true">✓</span>
                              )}
                            </button>
                          );
                        })}
                      </div>

                      <div className="odx-face-summary">
                        <span>
                          Superficies seleccionadas: <strong>{carasSeleccionadas.length}</strong>
                        </span>
                        <span>
                          {carasSeleccionadas.length
                            ? carasSeleccionadas
                                .map((cara) => nombreCara(cara))
                                .join(" · ")
                            : "Ninguna"}
                        </span>
                      </div>

                      <p className="odx-step-description" style={{ marginTop: 12 }}>
                        Ejemplo: para una lesión MOD, selecciona Mesial, Oclusal y Distal.
                      </p>

                      {/* El botón queda al final para confirmar el conjunto de superficies. */}
                      <button
                        type="button"
                        className="odx-primary"
                        onClick={guardarCondicion}
                        disabled={
                          !condicion || carasSeleccionadas.length === 0
                        }
                      >
                        Aplicar condición a {carasSeleccionadas.length}{" "}
                        {carasSeleccionadas.length === 1 ? "cara" : "caras"}
                      </button>
                    </>
                  )}
                </>
              )}

              <div className="odx-subtitle">
                <span>Condiciones registradas</span>
                <span className="odx-count">
                  {registrosSeleccionados.length}
                </span>
              </div>

              {registrosSeleccionados.length === 0 ? (
                <div className="odx-empty">
                  Aún no hay condiciones registradas para esta pieza.
                </div>
              ) : (
                registrosSeleccionados.map((registro, indice) => (
                  <div
                    className="odx-record"
                    key={`${registro.scope}-${registro.face || ""}-${registro.condition}-${indice}`}
                  >
                    <div className="odx-record-name">
                      <span
                        className="odx-record-dot"
                        style={{
                          background:
                            COLORES[registro.condition] || "#64748b",
                        }}
                      />
                      <span>
                        {nombreCondicion(registro)}
                        <small>
                          {registro.scope === "cara"
                            ? nombreCara(registro.face)
                            : "Diente completo"}
                        </small>
                      </span>
                    </div>

                    {!readOnly && (
                      <button
                        type="button"
                        className="odx-remove"
                        onClick={() => quitarRegistro(indice)}
                      >
                        Quitar
                      </button>
                    )}
                  </div>
                ))
              )}
            </div>
          </section>
        </div>
      )}
    </div>
  );
}
